import SlideshowLink from './Slideshow';

export default SlideshowLink;
